<template>
    <div>
        <div class="tw:flex tw:items-center tw:justify-center">
            <div
                class="tw:w-16 tw:h-16 tw:rounded-full tw:animate-spin tw:border-8 tw:border-dotted
                       tw:border-hiorg-blau-400 tw:border-t-transparent"
            />
        </div>
        <div class="tw:mt-5 tw:flex tw:items-center tw:justify-center">
            {{ text }}
        </div>
    </div>
</template>

<script setup lang="ts">
defineProps<{
    text: string;
}>();
</script>
